// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import store from './store'
import router from './router'
import './registerServiceWorker'
import mixin from './core/mixin'

import "@babel/polyfill";


import searchParams from 'url-search-params-polyfill';
Vue.use(searchParams);

// Plugins init
import overlay from './plugins/overlay'; Vue.use(overlay);

Vue.config.productionTip = false

// LANGUAGE
import "./core/filters"
import i18n from './i18n'
Vue.use(i18n)

// Layouts

import Inscripcion from "./layouts/Inscripcion-Layout.vue";
Vue.component( "inscripcion-layout", Inscripcion );

import VueTelInput from 'vue-tel-input'
Vue.use(VueTelInput)

import Vuetify from 'vuetify'

// Vue.use(Vuetify)
Vue.use(Vuetify, { theme: false })
import 'vuetify/dist/vuetify.min.css'

new Vue({
    el: '#app',
    store,
    i18n,
    router,
    components: { App },
    template: '<App/>',
    mixins: [mixin],
});